/* eslint-disable max-lines-per-function */

import { AccordionContent, AccordionItem, AccordionTrigger } from '@e2n/ui';
import { Button } from '@e2n/ui';
import { FristenMobile } from '@/domain/mitarbeiter/features/anlageassistent/content/Anstellungsverhaeltnis/Fristen/FristenMobile/FristenMobile';
import { FristenTable } from '@/domain/mitarbeiter/features/anlageassistent/content/Anstellungsverhaeltnis/Fristen/FristenTable/FristenTable';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';

import {
  faFileContract,
  faPenToSquare,
} from '@fortawesome/pro-regular-svg-icons';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { formatDate } from '@/domain/mitarbeiter/features/anlageassistent/utils/formatDate';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function Anstellungsverhaeltnis() {
  const { t } = useTranslation();
  const { ctx } = useAnlageassistentContext();
  const form = useAnlageassistentFormContext();

  const data = form.state.values;

  return (
    <AccordionItem value="anstellungsverhaeltnis">
      <AccordionTrigger className="flex gap-1 py-0">
        <FontAwesomeIcon icon={faFileContract} />
        <span className="text-neutrals-900 text-xl font-bold leading-7">
          {t('domain.mitarbeiter.create.steps.anstellungsverhaeltnis.title')}
        </span>
      </AccordionTrigger>
      <AccordionContent>
        <div className="mt-4">
          <div className="flex items-center">
            <span className="text-neutrals-900 font-bold text-base leading-6">
              {t(
                'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.anstellung.title',
              )}
            </span>
            <Button
              className="ml-auto"
              variant={'icon'}
              onClick={() =>
                ctx.navigateToSubStep('anstellungsverhaeltnis.anstellung')
              }>
              <FontAwesomeIcon
                icon={faPenToSquare}
                className="text-primary-blue-600"
              />
            </Button>
          </div>

          <div className="py-2 grid grid-cols-2 gap-y-4 text-neutrals-800 leading-5 text-sm font-normal">
            <span>
              {t(
                'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.anstellung.form.anstellungstyp.label',
              )}
            </span>
            <span className="text-neutrals-900 font-semibold">
              {t(
                'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.anstellung.form.anstellungstyp.options.' +
                  data.anstellungsverhaeltnis.anstellung.anstellungstyp,
              )}
            </span>
            <span>
              {t(
                'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.anstellung.form.eintrittsdatum.label',
              )}
            </span>
            <span className="text-neutrals-900 font-semibold">
              {formatDate(
                data.anstellungsverhaeltnis.anstellung.eintrittsdatum,
              )}
            </span>
            <span>
              {t(
                'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.anstellung.form.befristetBis.label',
              )}
            </span>
            <span className="text-neutrals-900 font-semibold">
              {formatDate(data.anstellungsverhaeltnis.anstellung.befristung)}
            </span>
          </div>
        </div>
        <div className="mt-4">
          <div className="flex items-center">
            <span className="text-neutrals-900 font-bold text-base leading-6">
              {t(
                'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.title',
              )}
            </span>
            <Button
              className="ml-auto"
              variant={'icon'}
              onClick={() =>
                ctx.navigateToSubStep('anstellungsverhaeltnis.fristen')
              }>
              <FontAwesomeIcon
                icon={faPenToSquare}
                className="text-primary-blue-600"
              />
            </Button>
          </div>
          <FristenTable readonly />
          <FristenMobile readonly />
        </div>
      </AccordionContent>
    </AccordionItem>
  );
}
